import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useApplication } from "../contexts/ApplicationContext";

const baseCards = [
  {
    title: "Nova consulta",
    description: "Realize uma nova consulta na plataforma",
    img: "/assets/dashboard/icon_1.png",
    button: "Consultar",
    link: "/queries/credits",
  },
  {
    title: "Histórico",
    description: "Veja todas as suas consultas anteriores",
    img: "/assets/dashboard/icon_2.png",
    button: "Ver histórico",
    link: "/reports/queries",
  },
  {
    title: "Pagamentos",
    description: "Visualize suas faturas em aberto",
    img: "/assets/dashboard/icon_3.png",
    button: "Ver faturas",
    link: "/invoices",
  },
  {
    title: "Integração API",
    description: "Conecte sua aplicação à nossa API oficial",
    img: "/assets/dashboard/icon_4.png",
    button: "Ver API",
    link: "/docs",
  },
];


const sellerCards = [
  {
    title: "Nova consulta",
    description: "Realize uma nova consulta na plataforma",
    img: "/assets/dashboard/icon_1.png",
    button: "Consultar",
    link: "/queries/credits",
  },
  {
    title: "Histórico",
    description: "Veja todas as suas consultas anteriores",
    img: "/assets/dashboard/icon_2.png",
    button: "Ver histórico",
    link: "/reports/queries",
  },
  {
    title: "Meus clientes",
    description: "Gerencie a sua carteira de clientes",
    img: "/assets/dashboard/icon_3.png",
    button: "Abrir",
    link: "/my-customers",
  },
  {
    title: "Suporte",
    description: "Fale com nosso time e tire dúvidas",
    img: "/assets/dashboard/icon_4.png",
    button: "Abrir suporte",
    link: "/support",
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.15, duration: 0.4, ease: "easeOut" },
  }),
};

export default function QuickActions({ company }) {
  const { userPermission } = useApplication();
  const navigate = useNavigate();

  const isSeller = Array.isArray(userPermission)
    ? userPermission.includes("SELLER")
    : userPermission === "SELLER";

  const visibleCards = useMemo(() => {
    const cards = isSeller ? sellerCards : baseCards;
    return company?.isOnline ? cards.filter((c) => c.link !== "/docs") : cards;
  }, [company?.isOnline, isSeller]);

  return (
    <>
      <div className="mt-10 mb-6 relative">
        <div className="flex items-center gap-4">
          <div className="w-1.5 h-10 bg-gradient-to-b from-blue-700 to-blue-900 rounded-sm"></div>
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-gray-700 relative">
              Acesso rápido
            </h2>
            <p className="text-sm text-gray-500">
              Funcionalidades principais ao seu alcance
            </p>
          </div>
        </div>
      </div>

      <div className="mt-2">
        <Swiper
          spaceBetween={16}
          slidesPerView="auto"
          className="overflow-x-auto pb-10"
          modules={[Pagination]}
          pagination={{ clickable: true }}
        >
          {visibleCards.map((card, i) => (
            <SwiperSlide
              key={card.link}
              style={{ width: "320px" }}
              className="flex-shrink-0"
            >
              <motion.div
                custom={i}
                variants={cardVariants}
                initial="hidden"
                animate="visible"
                whileHover={{ y: -4, scale: 1.01 }}
                transition={{ duration: 0.25 }}
                className="rounded-2xl shadow-lg border border-gray-100 bg-white overflow-hidden flex flex-col justify-between h-full p-1"
              >
                <div className="relative h-[140px] bg-gray-50 flex items-center justify-center rounded-2xl">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="h-28 object-contain"
                  />
                </div>

                <div className="p-3 flex flex-col justify-between h-full">
                  <div className="flex-1">
                    <h3 className="text-base font-semibold text-gray-800 mb-1">
                      {card.title}
                    </h3>
                    <p className="text-sm text-gray-500 h-[48px] leading-snug">
                      {card.description}
                    </p>
                  </div>

                  <div className="mt-5">
                    <button
                      onClick={() => navigate(card.link)}
                      className="w-full text-sm font-semibold text-white bg-gradient-to-r from-blue-600 via-blue-700 to-blue-800 py-2.5 rounded-xl shadow-md hover:brightness-110 transition-all"
                    >
                      {card.button}
                    </button>
                  </div>
                </div>
              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
}
